import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';

export default function Hero() {
  return (
    <section data-testid="hero-section" className="hero-dark min-h-[90vh] flex items-center relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32 w-full">
        <div className="text-center max-w-4xl mx-auto">
          <div className="accent-line mb-8 mx-auto animate-fade-in-up"></div>
          <h1 
            data-testid="hero-headline"
            className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6 animate-fade-in-up animate-delay-100"
          >
            Costruiamo il Futuro
            <span className="text-[#E94560]"> Industriale</span>
          </h1>
          <p 
            data-testid="hero-subheadline"
            className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto animate-fade-in-up animate-delay-200"
          >
            Il partner strategico per il recruiting tecnico e l'intermediazione EPC. 
            Trova i migliori talenti in <span className="text-[#E94560] font-bold">48 ore</span>.
          </p>
          
          {/* Stats badge */}
          <div className="flex justify-center gap-8 mb-10 animate-fade-in-up animate-delay-200">
            <div className="bg-[#27AE60] text-white px-6 py-4 shadow-xl">
              <span className="text-3xl font-extrabold">48h</span>
              <span className="block text-sm mt-1">Attivazione rapida</span>
            </div>
            <div className="bg-white/10 text-white px-6 py-4 border border-white/20">
              <span className="text-3xl font-extrabold">100+</span>
              <span className="block text-sm mt-1">Profili disponibili</span>
            </div>
            <div className="bg-white/10 text-white px-6 py-4 border border-white/20">
              <span className="text-3xl font-extrabold">30+</span>
              <span className="block text-sm mt-1">Aziende nel network</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animate-delay-300">
            <Link 
              to="/servizi" 
              data-testid="hero-cta-services"
              className="btn-primary inline-flex items-center justify-center gap-2"
            >
              Scopri i servizi
              <ArrowRight size={20} />
            </Link>
            <Link 
              to="/lavora-con-noi" 
              data-testid="hero-cta-work"
              className="btn-secondary inline-flex items-center justify-center gap-2 !border-white !text-white hover:!bg-white hover:!text-[#1A1A2E]"
            >
              Lavora con noi
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <ChevronDown size={32} />
      </div>
    </section>
  );
}
